export default __webpack_public_path__ + "static/media/orangeVector.900c4127.svg";